export default {
  path: 'partner-groups/:id',
  name: 'PartnerGroup',
  component: () => import(/* webpackChunkName: "administration" */ '../views/PartnerGroupView.vue')
}
